/**
 * @generated SignedSource<<b8a66e36f4aac0bee056b4daa45caf5a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPageTracker_item$data = {
  readonly isMultiSku: boolean;
  readonly skus: ReadonlyArray<{
    readonly images: ReadonlyArray<{
      readonly __typename: "ItemPhoto";
    } | null> | null;
    readonly skuId: string | null;
  } | null> | null;
  readonly " $fragmentType": "PdpSharedPageTracker_item";
};
export type PdpSharedPageTracker_item$key = {
  readonly " $data"?: PdpSharedPageTracker_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPageTracker_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "PdpSharedPageTracker_item"
};

(node as any).hash = "dfba971de0748a6f43ebcbfebf8dd54c";

export default node;
